define([
  'es6!launcher/util/listbuilder/suggestions/email',
], (Email) => ({
  Email,
}));
